import { render, staticRenderFns } from "./ClientSlaAgreements.vue?vue&type=template&id=2ea6c1f4&scoped=true&"
import script from "./ClientSlaAgreements.vue?vue&type=script&lang=js&"
export * from "./ClientSlaAgreements.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ea6c1f4",
  null
  
)

export default component.exports